import { Variant } from '@kizi/core-components';

const rowAccordionContainer: Variant = {
  display: 'flex',
  flexDirection: 'column',
  paddingRight: [0, 0, 0, 3],
};
const comparisonTableRow: Variant = {
  paddingRight: [0, 3, 3, 3],
};

const tableRows = {
  rowAccordionContainer,
  comparisonTableRow,
};

export default tableRows;
